import { ControlValueAccessor } from "@angular/forms";

export class BaseFormControlComponent<TValueType> implements ControlValueAccessor {
    private _value: TValueType;

    protected get value(): TValueType {
        return this._value;
    }

    private _disabled: boolean = false;

    protected get disabled(): boolean {
        return this._disabled;
    }

    // tslint:disable-next-line:semicolon
    private onChange: any = () => {};

    // tslint:disable-next-line:semicolon
    private onTouched: any = () => {};

    /**
     * Registers a callback function that is called when the control's value changes in the UI.
     */
    public registerOnChange(fn: () => void): void {
        this.onChange = fn;
    }

    /**
     * Registers a callback function that is called by the forms API on initialization to update the form model on blur.
     */
    public registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    /**
     * Function that is called by the forms API when the control status changes to or from "DISABLED".
     */
    public setDisabledState(disabled: boolean): void {
        this._disabled = disabled;
    }

    /**
     * Writes a new value to the element.
     */
    public writeValue(value: any): void {
        this._value = value;
    }

    protected writeNewValue(value: TValueType): void {
        if (value !== undefined) {
            this.writeValue(value);
            this.onChange(value);
        }
    }
}
